/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore comprehensive driver and constructor statistics with historical trends.`)
};

const es_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora estadísticas completas de pilotos y constructores con tendencias históricas.`)
};

const de_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecke umfassende Fahrer- und Konstrukteurstatistiken mit historischen Trends.`)
};

const nl_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek uitgebreide coureurs- en constructeursstatistieken met historische trends.`)
};

const fr_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorez des statistiques complètes sur les pilotes et constructeurs avec des tendances historiques.`)
};

const it_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora statistiche complete di piloti e costruttori con trend storici.`)
};

const pt_br2_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore estatísticas completas de pilotos e construtores com tendências históricas.`)
};

const pt_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore estatísticas completas de pilotos e construtores com tendências históricas.`)
};

const ja_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歴史的トレンドを含むドライバーとコンストラクターの包括的な統計を探索。`)
};

const zh_f1_home_card_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索附带历史趋势的车手和车队综合统计数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_card_stats_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_card_stats_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_card_stats_desc", locale)
	if (locale === "en") return en_f1_home_card_stats_desc(inputs)
	if (locale === "es") return es_f1_home_card_stats_desc(inputs)
	if (locale === "de") return de_f1_home_card_stats_desc(inputs)
	if (locale === "nl") return nl_f1_home_card_stats_desc(inputs)
	if (locale === "fr") return fr_f1_home_card_stats_desc(inputs)
	if (locale === "it") return it_f1_home_card_stats_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_card_stats_desc(inputs)
	if (locale === "pt") return pt_f1_home_card_stats_desc(inputs)
	if (locale === "ja") return ja_f1_home_card_stats_desc(inputs)
	return zh_f1_home_card_stats_desc(inputs)
};